module.exports = __webpack_public_path__ + "static/media/frida.5f41b2ea.jpg";